/**
 * Add FAQ view — UI only; state from useAddFaqViewModel.
 */

import { LoadingSpinner } from '@/features/common/components/LoadingSpinner'
import { ArrowLeft } from 'lucide-react'
import { useAddFaqViewModel } from '../viewmodels/use_add_faq_viewmodel'

export function AddFaqPageView() {
  const { form, actions } = useAddFaqViewModel()
  const { question, answer, isActive, errors, isSubmitting } = form

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <button
          onClick={actions.cancel}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">Add FAQ</h1>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <form
          onSubmit={e => {
            e.preventDefault()
            void actions.submit()
          }}
          className="space-y-6"
        >
          {/* Question */}
          <div>
            <label htmlFor="question" className="block text-sm font-medium text-gray-700 mb-2">
              Question<span className="text-red-500">*</span>
            </label>
            <input
              id="question"
              type="text"
              value={question}
              onChange={e => {
                actions.setQuestion(e.target.value)
                actions.clearFieldError('question')
              }}
              placeholder="Enter Question"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                errors.question ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.question && <p className="mt-1 text-sm text-red-600">{errors.question}</p>}
          </div>

          {/* Answer */}
          <div>
            <label htmlFor="answer" className="block text-sm font-medium text-gray-700 mb-2">
              Answer<span className="text-red-500">*</span>
            </label>
            <textarea
              id="answer"
              value={answer}
              onChange={e => {
                actions.setAnswer(e.target.value)
                actions.clearFieldError('answer')
              }}
              placeholder="Enter Your Answer..."
              rows={6}
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 resize-y ${
                errors.answer ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.answer && <p className="mt-1 text-sm text-red-600">{errors.answer}</p>}
          </div>

          {/* Active Checkbox */}
          <div>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={isActive}
                onChange={e => actions.setIsActive(e.target.checked)}
                className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
              />
              <span className="text-sm font-medium text-gray-700">Active</span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end gap-4 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={actions.cancel}
              className="px-6 py-2 text-sm font-medium bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 text-sm font-medium text-white rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#019b9a' }}
            >
              {isSubmitting ? (
                <span className="flex items-center gap-2">
                  <LoadingSpinner size="sm" />
                  Saving...
                </span>
              ) : (
                'Save'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
